import {
  UPDATE_SCENARIO_REPORT_VALUE,
  UPDATE_SCENARIO_REPORT_VALUE_FAILURE,
  UPDATE_SCENARIO_REPORT_VALUE_SUCCESS,
  RESET_SCENARIO_REPORT_VALUE,
  RESET_SCENARIO_REPORT_VALUE_FAILURE,
  RESET_SCENARIO_REPORT_VALUE_SUCCESS,
} from './types';

import {
  updateScenarioReportValue as updateScenarioReportValueApi,
  resetScenarioReportValue as resetScenarioReportValueApi,
} from '../../shared/api';
import { errorNotification, successNotification } from '../../../shared/store/notificationActions';
import { fetchingError } from '../../../shared/store/actions';

export const updateReportValue = (
  {
    reportName,
    scenarioId,
    companyCode,
    countryTaxType,
    fieldName,
    value,
  },
  { onSuccessCallback } = {}
) => async dispatch => {
  try {
    dispatch({ type: UPDATE_SCENARIO_REPORT_VALUE });
    await updateScenarioReportValueApi({
      reportName,
      scenarioId,
      companyCode,
      countryTaxType,
      fieldName,
      value,
    });
    dispatch({ type: UPDATE_SCENARIO_REPORT_VALUE_SUCCESS });
    dispatch(successNotification('Report value updated successfully'));
    if (onSuccessCallback) {
      onSuccessCallback();
    }
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      dispatch({ type: UPDATE_SCENARIO_REPORT_VALUE_FAILURE });
      return;
    }
    throw error;
  }
};

export const resetReportValue = (
  {
    reportName,
    scenarioId,
    companyCode,
    countryTaxType,
    fieldName,
  },
  { onSuccessCallback } = {}
) => async dispatch => {
  try {
    dispatch({ type: RESET_SCENARIO_REPORT_VALUE });
    await resetScenarioReportValueApi({
      reportName,
      scenarioId,
      companyCode,
      countryTaxType,
      fieldName,
    });
    dispatch({ type: RESET_SCENARIO_REPORT_VALUE_SUCCESS });
    dispatch(successNotification('Report value updated successfully'));
    if (onSuccessCallback) {
      onSuccessCallback();
    }
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      dispatch({ type: RESET_SCENARIO_REPORT_VALUE_FAILURE });
      return;
    }
    throw error;
  }
};
